// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_2j-6";
export var headerCell = "_2j-2";
export var loadingStateContent = "_2j-8";
export var rowWrapper = "_2j-4";
export var stickyAggregationCell = "_2j-b";
export var stickyAggregationRow = "_2j-7";
export var stickyColumnCell = "_2j-a";
export var stickyColumnHeaderCell = "_2j-9";
export var table = "_2j-1";
export var virtualRowWrapper = "_2j-5";
export var virtualTableBodyFiller = "_2j-d";
export var virtualTableBodyFillerBottom = "_2j-e";
export var virtualTableContainer = "_2j-0";
export var virtualTableContainerFill = "_2j-c";
export var white = "_2j-3";